import { render, staticRenderFns } from "./PolicyDocumentUrlsLog.vue?vue&type=template&id=9e6e540c&"
import script from "./PolicyDocumentUrlsLog.vue?vue&type=script&lang=js&"
export * from "./PolicyDocumentUrlsLog.vue?vue&type=script&lang=js&"
import style0 from "./PolicyDocumentUrlsLog.vue?vue&type=style&index=0&id=9e6e540c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports